module.exports = __webpack_public_path__ + "img/program-rock.575827c7.jpg";